import { render, staticRenderFns } from "./BaseDocumentApplicationUsageWidget.vue?vue&type=template&id=caf71b0e"
import script from "./BaseDocumentApplicationUsageWidget.vue?vue&type=script&lang=ts"
export * from "./BaseDocumentApplicationUsageWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports